export enum ItsOverNineThousandFeatureFlags {
    PermSubmittalRevampUi = 'PermSubmittalRevamp-UI',

    // 25.02
    NovaDisablePermRecruitingModule = 'nova-disable-perm-recruiting-module',

    // 25.03
    NovaCorehireAmJobsDetailsUpdates = 'nova-corehire-am-jobs-details-updates',

    // 25.04
    NovaApplyWithAyaQuestionAnswers = 'nova-apply-with-aya-question-answers'
}
